import { primaryBase, redBase, skyDark } from '../../../../styles/design-tokens';

// Trend colors from design tokens
const TREND_COLORS = {
  good: primaryBase, // #23c16b - green
  bad: redBase, // #ff5247 - red
  neutral: skyDark, // #979c9e - gray
} as const;

type TrendDirection = 'up' | 'down' | 'flat';
type DesiredTrendlineDirection = 'up' | 'down';
type TrendColor = (typeof TREND_COLORS)[keyof typeof TREND_COLORS];

export { TREND_COLORS };
export type { DesiredTrendlineDirection, TrendColor, TrendDirection };
